import { render, staticRenderFns } from "./DistanceListItem.vue?vue&type=template&id=4dbf5243"
import script from "./DistanceListItem.vue?vue&type=script&lang=js"
export * from "./DistanceListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports